import { Component } from '@angular/core';

@Component({
  selector: 'app-partner',
  standalone: true,
  imports: [],
  templateUrl: './partner.component.html',
  styleUrl: './partner.component.scss'
})
export class PartnerComponent {
  titleTexts = [
    'partners',
    'p@r7#er$',
    '642/n3r5',
    '642/$3?',
    'f#13£02',
    'f#13n05',
    'fr12n05',
    'friends'
  ];

  textStep = 0;
  reverse = false;
  isAnimating = false;

  startAnimation() {
    if (!this.isAnimating) {
      this.isAnimating = true;
      let intervalID = setInterval(() => {
        if (this.textStep < 7 && !this.reverse) {
          this.textStep++;
        }
        if (this.textStep === 7 && !this.reverse) {
          setTimeout(() => this.reverse = true, 600)
        }
        if (this.textStep > 0 && this.reverse) {
          this.textStep--;
        }
        if (this.textStep === 0 && this.reverse) {
          this.reverse = false;
          clearInterval(intervalID);
          this.isAnimating = false;
        }
        return;
      }, 150)
    }
  }
}
